import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';

export interface VerifizierungInfoProps {
    data: any;
}

export class VerifizierungInfo extends React.Component<VerifizierungInfoProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', minHeight: 0, overflowY: 'auto' }}>
                <div style={{ width: 1350, padding: '0 20px', textAlign: 'justify' }}>
                    {renderText('validierung_info', this.props.data)}
                </div>
            </div>
        );
    }
}
